import { z } from 'zod';
import { momentSchema } from './momentSchema';

/**
 * Entity collection names in firestore
 *
 * Add in alphabetical order, please
 */
export enum Collection {
  Clinics = 'clinics',
  Clinicians = 'clinicians',
  Patients = 'patients',
  PatientAssessments = 'patientAssessments',
  PatientInjuries = 'patientInjuries',
  PatientPersonalHistory = 'patientPersonalHistories',
  PendingPatientAssessments = 'pendingPatientAssessments',
  PatientProfiles = 'patientProfiles',
  TreatmentGoals = 'treatmentGoals'
}

/* Add in alphabetical order, please */
export enum PatientSubcollection {
  ClinicianWorksheetRatings = 'clinicianWorksheetRatings',
  ClinicianWorksheetScores = 'clinicianWorksheetScores',
  ClinicianWorksheets = 'clinicianWorksheets',
  Goals = 'goals',
  HowAreYou = 'howAreYou',
  ImpactApi = 'impactAPI',
  Problems = 'problems',
  QualityOfLife = 'qualityOfLife',
  Scores = 'scores',
  SectionAnswers = 'sectionAnswers',
  SubSymptoms = 'subSymptoms',
  SymptomCalcInfo = 'symptomCalcInfo',
  Symptoms = 'symptoms',
  InventoriesDhi = 'inventoriesDhi',
  InventoriesPcs = 'inventoriesPcs',
  InventoriesPromis = 'inventoriesPromis',
  InventoriesCgs = 'inventoriesCgs',
  InventoriesImpact = 'inventoriesImpact',
  InventoriesConcussionTreatmentRecommendations = 'inventoriesConcussionTreatmentRecommendations',
  
  InventoriesDemographic = 'inventoriesDemographic',
  InventoriesInjury = 'inventoriesInjury',

  Onboardings = 'onboardings',
  ConcussionClassifications = 'concussionClassifications',
  SubtypeRangeResults = 'subtypeRangeResults',
  AssessmentIndex = 'assessmentIndex',
}

export const QUESTIONNAIRE_INVENTORIES = [
  PatientSubcollection.InventoriesPromis,
  PatientSubcollection.InventoriesCgs,
  PatientSubcollection.InventoriesDhi,
  PatientSubcollection.InventoriesImpact,
  PatientSubcollection.InventoriesPcs,
  PatientSubcollection.InventoriesDemographic,
  PatientSubcollection.InventoriesInjury
] as const;

// export enum ApiSubCollection {
//   Impact = "impact"
// }


export const documentMetadataSchema = z.object({
  created: momentSchema,
  updated: momentSchema.optional()
});

export interface DocumentMetadata
  extends z.infer<typeof documentMetadataSchema> {}

export const documentSchema = z.object({
  id: z.string(),
  metadata: documentMetadataSchema.optional(),
  /**
   * This field is automatically generated when using the `createRepo` API
   */
  schemaVersion: z.string().optional()
});

export interface Document extends z.infer<typeof documentSchema> {}
